// src/pages/Dashboard.jsx

import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { FaUsers, FaMoneyBillWave, FaUtensils, FaBoxOpen } from "react-icons/fa";
import './Dashboard.css'; // Import the stylesheet

const Dashboard = () => {
  const { user } = useOutletContext() || {};
  const [totalCustomers, setTotalCustomers] = useState(84);
  const [totalExpense, setTotalExpense] = useState("$ 1,250.00");
  const [numberOfFoods, setNumberOfFoods] = useState(42);
  const [numberOfPackages, setNumberOfPackages] = useState(15);

  // Your useEffect for fetching data is perfect, no changes needed.

  const statCards = [
    { label: "Total Customers", value: totalCustomers, icon: <FaUsers />, className: "card-customers" },
    { label: "Total Expense", value: totalExpense, icon: <FaMoneyBillWave />, className: "card-expense" },
    { label: "Number of Foods", value: numberOfFoods, icon: <FaUtensils />, className: "card-foods" },
    { label: "Number of Packages", value: numberOfPackages, icon: <FaBoxOpen />, className: "card-packages" },
  ];

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h1>Welcome {user?.username || 'User'}, 👋</h1>
      </div>

      <div className="summary-cards-grid">
        {statCards.map((card, index) => (
          <div key={index} className={`stat-card ${card.className}`}>
            <div className="card-info">
              <div className="card-label">{card.label}</div>
              <div className="card-value">{card.value}</div>
            </div>
            <div className="card-icon">{card.icon}</div>
          </div>
        ))}
      </div>

      <div className="chart-container">
        <h2>📊 Sales Last 30 Days</h2>
        <div className="chart-placeholder">
          (Chart Placeholder)
        </div>
      </div>
    </div>
  );
};

export default Dashboard;